import { Box, Typography } from '@mui/material'
import CustomOption2 from '../components/CustomOption2'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
const DangerousGoods = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light" sx={{ mb: 6 }}>
        <span className="general-text">Task Name - </span>Hazardous / Dangerous
        Goods
      </Typography>
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="Generic Painting Chemical Products"
        name="Generic_Painting_Chemical_Products"
        component={
          <Box>
            <CustomOption2
              label="Chemical exposure - "
              name="Chemical_exposure"
              warning={true}
              sliderDescription="Ensure current and valid SDS available for all dangerous/hazardous goods used. Ensure all PPE nominated in the SDS is readily available for use the work area and all air filters are in suitable condition"
            />
            <CustomOption2
              label="Contaminated Waste -"
              name="Contaminated_Waste"
              warning={true}
              sliderDescription="Dispose of all contaminated wastes, using correct procedures. Return unwanted paint to the office for recycling or disposal."
            />
          </Box>
        }
        conditional_heading="Generic Painting Chemical Products"
      />
    </Box>
  )
}

export default DangerousGoods
